import { BASE_ENDPOINT } from "../../endpoint";

export const downloadPayrollReport = async (TOKEN, companyId, payrollIds) => {
    try {
        const baseurl = `${BASE_ENDPOINT}/api/reports/payroll-history/${companyId}/export`;
        const url = new URL(baseurl);
        if (payrollIds && payrollIds.length > 0) {
            payrollIds.forEach((id) => url.searchParams.append("payrollIds", id));
        }

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            const errorResponse = await response.text(); // Get error message
            console.error('Error:', errorResponse);
            throw new Error(errorResponse);
        }
        // Return response as a Blob for binary data
        return await response.blob();
    } catch (error) {
        console.error("API fetch error:", error);
        throw error;
    }
};
